import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { DataSearchMultipleFiles, ImagesFiles } from "../models/util/claims";
import { TransactionsToBackUpRequestModel } from "@app/models/TransactionsToBackupModel";
import { TransactionsToBackupResponse } from "@app/models/TransactionsToBackupResponse";
import { CreateBackingsRequest } from "@app/models/CreateBackings.model";
import { CreateBackingsResponse } from "@app/models/CreateBackingsResponse.model";
import { SearchAffiliateModel } from "@app/models/SearchAffiliateModel";
import { BackingsToProcessRequestModel } from "@app/models/backingsToProcessRequest.model";
import { BackingsToProcessResponseModel } from "@app/models/backingsToProcessResponse.model";
import { AffiliatesResponse } from "@app/models/SearchAffiliate.model";
import { map } from "rxjs/operators";
import { PaymentProcessBackingRequest } from "@app/models/paymentProcessBacking.model";
import { Observable } from "rxjs";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xls";

@Injectable({
  providedIn: "root",
})
export class BackupsService {
  public urlApi: string = "";
  public timeout: number = 0;
  public headers: HttpHeaders = new HttpHeaders();
  public backingsToken: string = "";

  constructor(private http: HttpClient) {
    this.urlApi = environment.postgres ? environment.urlApiBacking : `${environment.urlApiBacking}/backingsPostgreSQL`;
    this.timeout = 30000;
    this.backingsToken = environment.backingsApiKey;
  }

  getSearchCv(dataCv: string, numberPage: number, size: number) {
    const headers = new HttpHeaders();
    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/x-www-form-urlencoded");
    const params = {
      CV: dataCv,
      pageNo: `${numberPage}`,
      size: `${size}`,
    };

    const options = { headers, params };

    return this.http.get(
      `${this.urlApi}/respaldos/getImageByCV`,
      options
    );
  }

  postSearchFiles(data: DataSearchMultipleFiles) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": `Basic ${btoa(this.backingsToken)}`
    });

    const options = { headers };
    return this.http.post(
      `${this.urlApi}/respaldos/covifactura/findImageByCriteria`,
      data,
      options
    );
  }

  postSaveFiles(data: ImagesFiles) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": `Basic ${btoa(this.backingsToken)}`
    });

    const options = { headers };
    return this.http.post(
      `${this.urlApi}/respaldos/saveMassiveImages`,
      data,
      options
    );
  }

  getTransactionsToBackUp(
    getTransactionsRequest: TransactionsToBackUpRequestModel
  ) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(this.backingsToken)}`
    });

    const options = {
      headers,
    };
    return this.http
      .post<TransactionsToBackupResponse>(
        `${this.urlApi}/backings/getTransactionsToBackUp`,
        getTransactionsRequest,
        options
      )
      .pipe(
        map(
          (transactionsToBackUp: TransactionsToBackupResponse) =>
            transactionsToBackUp
        )
      );
  }

  createBacking(createBackingsRequest: CreateBackingsRequest) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(this.backingsToken)}`
    });

    const options = {
      headers,
    };

    return this.http
      .post<CreateBackingsResponse>(
        `${this.urlApi}/backings/createBacking`,
        createBackingsRequest,
        options
      )
      .pipe(
        // timeout(120000),
        map(
          (createBackingsResponse: CreateBackingsResponse) =>
            createBackingsResponse
        )
      );
  }

  public getAffiliate(searchAffiliate: SearchAffiliateModel): any {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(this.backingsToken)}`
    });

    const params: any = Object.assign({}, searchAffiliate);

    for (const keyParam in params) {
      if (!params[keyParam]) {
        searchAffiliate[keyParam] = "";
        delete params[keyParam];
      }
    }

    if (params.type === "0") {
      params.search = encodeURIComponent(params.search);
    }

    const options = {
      headers,
    };

    return this.http
      .post<AffiliatesResponse>(
        `${this.urlApi}/searching/searchFilter`,
        params,
        options
      )
      .pipe(
        map(
          (affiliatesListResponse: AffiliatesResponse) => affiliatesListResponse
        )
      );
  }

  public getBackingToProcces(dataRequest: BackingsToProcessRequestModel) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization" : 'Basic '+btoa(this.backingsToken)
    });

    const options = { headers };
    
    return this.http.post<BackingsToProcessResponseModel>(
      `${this.urlApi}/backings/backingsToProcess`, 
      dataRequest, 
      options
    );
  }
  
  public setPaymentProcessBacking(dataRequest: PaymentProcessBackingRequest) : Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization" : 'Basic '+btoa(this.backingsToken)
    });

    const options = { headers };
    
    return this.http.post<any>(
      `${this.urlApi}/backings/processBackings`, 
      dataRequest, 
      options
    );
  }
}
